import { gql } from '@apollo/client';

export const UPSERT_COMMUNITY_WORKFLOWS = gql`
  mutation UpsertCommunityWorkflows($communityId: ID!, $type: String!, $input: UpsertCommunityWorkflowConfigurationInput!) {
    upsertCommunityWorkflowConfiguration(communityId: $communityId, type: $type, input: $input) {
      type
      topicActions {
        topicName
        actionNames
      }
      apiSettings {
        maxTps
        monthlyBudget
        accessClients {
          providerUrl
          clientIdList
        }
        contentTypeTps {
          text
          image
          audio
        }
      }
    }
  }
`;
